// src/components/Pricing.jsx

import { Icon } from '@iconify/react';
import { useState } from 'react';

const Pricing = () => {
  const [isYearly, setIsYearly] = useState(false);
  const [showAllFeatures, setShowAllFeatures] = useState({});

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  const toggleShowAllFeatures = (planName) => {
    setShowAllFeatures(prev => ({
      ...prev,
      [planName]: !prev[planName]
    }));
  };

  const plans = [
    {
      name: 'Basic',
      description: 'Untuk startup & UMKM',
      icon: '🟢',
      priceMonthly: 1500000,
      priceYearly: 14400000,
      features: [
        { name: '3 User Admin', included: true },
        { name: 'Maks. 50 Karyawan', included: true },
        { name: '1 Perusahaan', included: true },
        { name: 'Dashboard Recruitment', included: true },
        { name: 'Lowongan Kerja (Maks. 50 Job Posting)', included: true },
        { name: 'Kandidat', included: true },
        { name: 'Lamaran Online', included: true },
        { name: 'Tes Online', included: true },
        { name: 'Interview', included: true },
        { name: 'Offering & Hiring', included: true },
        { name: 'Laporan Recruitment', included: true },
        { name: 'Database Kandidat', included: true },
        { name: 'AI Screening CV (75 CV/hari)', included: true },
        { name: 'AI HR Assistant (30 prompt/hari)', included: true },
        { name: 'Dashboard Manajemen Karyawan', included: true },
        { name: 'Data Pegawai', included: true },
        { name: 'Shift Kerja', included: true },
        { name: 'Absensi', included: true },
        { name: 'Selfie Attendance', included: true },
        { name: 'Lokasi Absensi', included: true },
        { name: 'Cuti & Izin', included: true },
        { name: 'Dokumen HR', included: true },
        { name: 'Payroll', included: true },
        { name: 'Slip Gaji', included: true },
        { name: 'Laporan HR', included: true },
        { name: 'Support Email/Chat WhatsApp', included: true },
        { name: 'Help Center Website', included: true },
      ],
      featureCategories: [
        {
          name: '📊 KAPASITAS',
          items: ['3 User Admin', 'Maks. 50 Karyawan', '1 Perusahaan']
        },
        {
          name: '🎯 REKRUTMEN',
          items: [
            'Dashboard Recruitment',
            'Lowongan Kerja (Maks. 50 Job Posting)',
            'Kandidat',
            'Lamaran Online',
            'Tes Online',
            'Interview',
            'Offering & Hiring',
            'Laporan Recruitment',
            'Database Kandidat'
          ]
        },
        {
          name: '🤖 AI RECRUITMENT & AI HR ASSISTANT',
          items: [
            'AI Screening CV (75 CV/hari)',
            'AI HR Assistant (30 prompt/hari)'
          ]
        },
        {
          name: '👥 MANAJEMEN KARYAWAN',
          items: [
            'Dashboard Manajemen Karyawan',
            'Data Pegawai',
            'Shift Kerja',
            'Absensi',
            'Selfie Attendance',
            'Lokasi Absensi',
            'Cuti & Izin',
            'Dokumen HR',
            'Payroll',
            'Slip Gaji',
            'Laporan HR'
          ]
        },
        {
          name: '🛡️ SUPPORT',
          items: [
            'Support Email/Chat WhatsApp',
            'Help Center Website'
          ]
        }
      ],
      highlightFeatures: [
        '3 User Admin',
        '50 Karyawan',
        '1 Perusahaan',
        'AI Screening — 75 CV/hari',
        'AI HR Assistant — 30 prompt/hari',
        'Recruitment Dasar',
        'Employee Management',
        'Attendance & Payroll',
        'HR Reports',
        'Support Email/WhatsApp',
      ],
      isPopular: false,
      buttonText: 'Pilih Basic',
      bgColor: 'bg-white',
      borderColor: 'border-gray-200',
      textColor: 'text-gray-900',
      priceColor: 'text-gray-900',
      buttonStyle: 'border-2 border-zentra-600 text-zentra-600 hover:bg-zentra-50',
      tooltip: 'Cocok untuk startup dan UMKM yang baru memulai digitalisasi HR',
    },
    {
      name: 'Professional',
      description: 'Untuk perusahaan menengah',
      icon: '⭐',
      priceMonthly: 2700000,
      priceYearly: 25920000,
      features: [
        { name: '10 User Admin', included: true },
        { name: 'Maks. 300 Karyawan', included: true },
        { name: '1 Perusahaan', included: true },
        { name: 'Semua fitur BASIC', included: true },
        { name: 'Dashboard Recruitment', included: true },
        { name: 'Lowongan Kerja (UNLIMITED Job Posting)', included: true },
        { name: 'Kandidat', included: true },
        { name: 'Lamaran Online', included: true },
        { name: 'Tes Online', included: true },
        { name: 'Interview', included: true },
        { name: 'Offering & Hiring', included: true },
        { name: 'Laporan Recruitment', included: true },
        { name: 'Database Kandidat', included: true },
        { name: 'AI Screening CV (200 CV/hari)', included: true },
        { name: 'AI HR Assistant (75 prompt/hari)', included: true },
        { name: 'Dashboard Manajemen Karyawan', included: true },
        { name: 'Data Pegawai', included: true },
        { name: 'Shift Kerja', included: true },
        { name: 'Absensi', included: true },
        { name: 'Selfie Attendance', included: true },
        { name: 'Lokasi Absensi', included: true },
        { name: 'Cuti & Izin', included: true },
        { name: 'Dokumen HR', included: true },
        { name: 'Payroll', included: true },
        { name: 'Slip Gaji', included: true },
        { name: 'Laporan HR', included: true },
        { name: 'Finance Dashboard', included: true },
        { name: 'Pendapatan', included: true },
        { name: 'Pengeluaran', included: true },
        { name: 'Cash Flow', included: true },
        { name: 'Invoice', included: true },
        { name: 'Tagihan', included: true },
        { name: 'Pembayaran', included: true },
        { name: 'Budget Dasar', included: true },
        { name: 'Laporan Keuangan Dasar', included: true },
        { name: 'Expense Management Dasar', included: true },
        { name: 'Marketing Dashboard', included: true },
        { name: 'Campaign Management', included: true },
        { name: 'Lead Management Dasar', included: true },
        { name: 'Content Planning', included: true },
        { name: 'Content Calendar', included: true },
        { name: 'Social Media Planning', included: true },
        { name: 'Marketing Activity', included: true },
        { name: 'Marketing Report Dasar', included: true },
        { name: 'Basic Marketing Analytics', included: true },
        { name: 'Priority Support', included: true },
        { name: 'Email & Chat Support', included: true },
      ],
      featureCategories: [
        {
          name: '📊 KAPASITAS',
          items: ['10 User Admin', 'Maks. 300 Karyawan', '1 Perusahaan']
        },
        {
          name: '✅ SEMUA FITUR BASIC',
          items: ['Semua fitur yang ada di paket Basic']
        },
        {
          name: '🎯 REKRUTMEN',
          items: [
            'Dashboard Recruitment',
            'Lowongan Kerja (UNLIMITED Job Posting)',
            'Kandidat',
            'Lamaran Online',
            'Tes Online',
            'Interview',
            'Offering & Hiring',
            'Laporan Recruitment',
            'Database Kandidat'
          ]
        },
        {
          name: '🤖 AI RECRUITMENT & AI HR ASSISTANT',
          items: [
            'AI Screening CV (200 CV/hari)',
            'AI HR Assistant (75 prompt/hari)'
          ]
        },
        {
          name: '👥 MANAJEMEN KARYAWAN',
          items: [
            'Dashboard Manajemen Karyawan',
            'Data Pegawai',
            'Shift Kerja',
            'Absensi',
            'Selfie Attendance',
            'Lokasi Absensi',
            'Cuti & Izin',
            'Dokumen HR',
            'Payroll',
            'Slip Gaji',
            'Laporan HR'
          ]
        },
        {
          name: '💰 FINANCE BASIC',
          items: [
            'Finance Dashboard',
            'Pendapatan',
            'Pengeluaran',
            'Cash Flow',
            'Invoice',
            'Tagihan',
            'Pembayaran',
            'Budget Dasar',
            'Laporan Keuangan Dasar',
            'Expense Management Dasar'
          ]
        },
        {
          name: '📣 DIGITAL MARKETING BASIC',
          items: [
            'Marketing Dashboard',
            'Campaign Management',
            'Lead Management Dasar',
            'Content Planning',
            'Content Calendar',
            'Social Media Planning',
            'Marketing Activity',
            'Marketing Report Dasar',
            'Basic Marketing Analytics'
          ]
        },
        {
          name: '🛡️ SUPPORT',
          items: ['Priority Support', 'Email & Chat Support']
        }
      ],
      highlightFeatures: [
        '10 User Admin',
        '300 Karyawan',
        'UNLIMITED Job Posting',
        'AI Screening — 200 CV/hari',
        'AI HR Assistant — 75 prompt/hari',
        'Finance Basic',
        'Marketing Basic',
        'Advanced Analytics',
        'Priority Support',
      ],
      isPopular: true,
      buttonText: 'Pilih Professional',
      bgColor: 'bg-white',
      borderColor: 'border-zentra-600',
      textColor: 'text-gray-900',
      priceColor: 'text-zentra-600',
      buttonStyle: 'gradient-btn text-white hover:shadow-lg hover:shadow-zentra-500/25',
      tooltip: 'Paling populer! Cocok untuk perusahaan menengah yang membutuhkan fitur lengkap',
    },
    {
      name: 'Enterprise',
      description: 'Untuk korporasi besar',
      icon: '🏢',
      priceMonthly: 6300000,
      priceYearly: 60480000,
      features: [
        { name: 'UNLIMITED User Admin', included: true },
        { name: 'UNLIMITED Karyawan', included: true },
        { name: 'Maks. 3 Company', included: true },
        { name: 'Semua fitur Professional', included: true },
        { name: 'Dashboard Recruitment', included: true },
        { name: 'Lowongan Kerja (UNLIMITED Job Posting)', included: true },
        { name: 'Kandidat', included: true },
        { name: 'Lamaran Online', included: true },
        { name: 'Tes Online', included: true },
        { name: 'Interview', included: true },
        { name: 'Offering & Hiring', included: true },
        { name: 'Laporan Recruitment', included: true },
        { name: 'Database Kandidat', included: true },
        { name: 'AI Screening CV (500 CV/hari)', included: true },
        { name: 'AI HR Assistant (300 prompt/hari)', included: true },
        { name: 'Dashboard Manajemen Karyawan', included: true },
        { name: 'Data Pegawai', included: true },
        { name: 'Shift Kerja', included: true },
        { name: 'Absensi', included: true },
        { name: 'Selfie Attendance', included: true },
        { name: 'Lokasi Absensi', included: true },
        { name: 'Cuti & Izin', included: true },
        { name: 'Performance Management', included: true },
        { name: 'KPI Management', included: true },
        { name: 'Career Development', included: true },
        { name: 'Training Management', included: true },
        { name: 'Document Management', included: true },
        { name: 'HR Analytics', included: true },
        { name: 'Audit Log', included: true },
        { name: 'Advanced Payroll', included: true },
        { name: 'Slip Gaji', included: true },
        { name: 'Laporan HR', included: true },
        { name: 'Finance Dashboard', included: true },
        { name: 'Income Management', included: true },
        { name: 'Expense Management', included: true },
        { name: 'Cash Flow', included: true },
        { name: 'Budget Management', included: true },
        { name: 'Invoice', included: true },
        { name: 'Billing', included: true },
        { name: 'Payment', included: true },
        { name: 'Account Receivable', included: true },
        { name: 'Account Payable', included: true },
        { name: 'Expense Approval', included: true },
        { name: 'Budget Approval', included: true },
        { name: 'Financial Reporting', included: true },
        { name: 'Profit & Loss', included: true },
        { name: 'Cash Flow Report', included: true },
        { name: 'Financial Analytics', included: true },
        { name: 'Multi-Account', included: true },
        { name: 'Multi-Branch', included: true },
        { name: 'Multi-Company', included: true },
        { name: 'Marketing Dashboard', included: true },
        { name: 'Campaign Management', included: true },
        { name: 'Lead Management', included: true },
        { name: 'Content Planning', included: true },
        { name: 'Content Calendar', included: true },
        { name: 'Social Media Planning', included: true },
        { name: 'Marketing Activity', included: true },
        { name: 'Campaign Budget', included: true },
        { name: 'Marketing Expense', included: true },
        { name: 'Conversion Tracking', included: true },
        { name: 'Lead Source Analytics', included: true },
        { name: 'Marketing Analytics', included: true },
        { name: 'Campaign ROI', included: true },
        { name: 'Marketing Report', included: true },
        { name: 'Campaign Approval Workflow', included: true },
        { name: 'Advanced Role & Permission', included: true },
        { name: 'Audit Log', included: true },
        { name: 'Enterprise Security', included: true },
        { name: 'Dedicated Support', included: true },
        { name: 'Priority Technical Support', included: true },
        { name: 'SLA 99.9%', included: true },
        { name: 'API Access', included: true },
      ],
      featureCategories: [
        {
          name: '📊 KAPASITAS',
          items: ['UNLIMITED User Admin', 'UNLIMITED Karyawan', 'Maks. 3 Company']
        },
        {
          name: '✅ SEMUA FITUR PROFESSIONAL',
          items: ['Semua fitur yang ada di paket Professional']
        },
        {
          name: '🎯 REKRUTMEN',
          items: [
            'Dashboard Recruitment',
            'Lowongan Kerja (UNLIMITED Job Posting)',
            'Kandidat',
            'Lamaran Online',
            'Tes Online',
            'Interview',
            'Offering & Hiring',
            'Laporan Recruitment',
            'Database Kandidat'
          ]
        },
        {
          name: '🤖 AI RECRUITMENT & AI HR ASSISTANT',
          items: [
            'AI Screening CV (500 CV/hari)',
            'AI HR Assistant (300 prompt/hari)'
          ]
        },
        {
          name: '👥 MANAJEMEN KARYAWAN ENTERPRISE',
          items: [
            'Dashboard Manajemen Karyawan',
            'Data Pegawai',
            'Shift Kerja',
            'Absensi',
            'Selfie Attendance',
            'Lokasi Absensi',
            'Cuti & Izin',
            'Performance Management',
            'KPI Management',
            'Career Development',
            'Training Management',
            'Document Management',
            'HR Analytics',
            'Audit Log',
            'Advanced Payroll',
            'Slip Gaji',
            'Laporan HR'
          ]
        },
        {
          name: '💰 FINANCE ENTERPRISE',
          items: [
            'Finance Dashboard',
            'Income Management',
            'Expense Management',
            'Cash Flow',
            'Budget Management',
            'Invoice',
            'Billing',
            'Payment',
            'Account Receivable',
            'Account Payable',
            'Expense Approval',
            'Budget Approval',
            'Financial Reporting',
            'Profit & Loss',
            'Cash Flow Report',
            'Financial Analytics',
            'Multi-Account',
            'Multi-Branch',
            'Multi-Company'
          ]
        },
        {
          name: '📣 DIGITAL MARKETING ENTERPRISE',
          items: [
            'Marketing Dashboard',
            'Campaign Management',
            'Lead Management',
            'Content Planning',
            'Content Calendar',
            'Social Media Planning',
            'Marketing Activity',
            'Campaign Budget',
            'Marketing Expense',
            'Conversion Tracking',
            'Lead Source Analytics',
            'Marketing Analytics',
            'Campaign ROI',
            'Marketing Report',
            'Campaign Approval Workflow'
          ]
        },
        {
          name: '🔒 SECURITY & SUPPORT',
          items: [
            'Advanced Role & Permission',
            'Audit Log',
            'Enterprise Security',
            'Dedicated Support',
            'Priority Technical Support',
            'SLA 99.9%',
            'API Access'
          ]
        }
      ],
      highlightFeatures: [
        'UNLIMITED Admin & Karyawan',
        '3 Company',
        'AI Screening — 500 CV/hari',
        'AI HR Assistant — 300 prompt/hari',
        'Performance & KPI Management',
        'Advanced Finance (Multi-Branch)',
        'Advanced Marketing (Campaign ROI)',
        'API Access',
        'Dedicated Support',
        'SLA 99.9%',
      ],
      isPopular: false,
      buttonText: 'Pilih Enterprise',
      bgColor: 'bg-white',
      borderColor: 'border-gray-200',
      textColor: 'text-gray-900',
      priceColor: 'text-gray-900',
      buttonStyle: 'border-2 border-zentra-600 text-zentra-600 hover:bg-zentra-50',
      tooltip: 'Solusi terbaik untuk korporasi besar dengan kebutuhan kompleks',
    },
    {
      name: 'Custom',
      description: 'Solusi khusus perusahaan',
      icon: '👑',
      priceMonthly: null,
      priceYearly: null,
      features: [
        { name: 'Semua fitur Enterprise', included: true },
        { name: 'Custom Module', included: true },
        { name: 'Custom Dashboard', included: true },
        { name: 'Custom Workflow', included: true },
        { name: 'Custom Report', included: true },
        { name: 'Custom Approval', included: true },
        { name: 'Custom Role', included: true },
        { name: 'Custom Permission', included: true },
        { name: 'ERP Integration', included: true },
        { name: 'Accounting Integration', included: true },
        { name: 'CRM Integration', included: true },
        { name: 'HRIS Integration', included: true },
        { name: 'API Integration', included: true },
        { name: 'Third-Party Integration', included: true },
        { name: 'Custom API', included: true },
        { name: 'Legacy System Integration', included: true },
        { name: 'On-Premise Option', included: true },
        { name: 'Private Cloud', included: true },
        { name: 'Dedicated Infrastructure', included: true },
        { name: 'Custom Deployment', included: true },
        { name: 'Data Migration', included: true },
        { name: 'Custom Security Policy', included: true },
        { name: 'Advanced Access Control', included: true },
        { name: 'Custom Audit Requirement', included: true },
        { name: 'Custom Compliance Requirement', included: true },
        { name: 'Custom SLA', included: true },
        { name: 'Dedicated Account Manager', included: true },
        { name: 'Dedicated Technical Support', included: true },
        { name: 'Training', included: true },
        { name: 'Onboarding', included: true },
        { name: 'Implementation Assistance', included: true },
        { name: 'Data Migration Assistance', included: true },
        { name: 'White-Label Option', included: true },
        { name: 'Custom Contract', included: true },
        { name: 'AI Custom', included: true },
      ],
      featureCategories: [
        {
          name: '✅ SEMUA FITUR ENTERPRISE',
          items: ['Semua fitur yang ada di paket Enterprise']
        },
        {
          name: '👑 CUSTOM BUSINESS MODULE',
          items: [
            'Custom Module',
            'Custom Dashboard',
            'Custom Workflow',
            'Custom Report',
            'Custom Approval',
            'Custom Role',
            'Custom Permission'
          ]
        },
        {
          name: '🔗 CUSTOM INTEGRATION',
          items: [
            'ERP Integration',
            'Accounting Integration',
            'CRM Integration',
            'HRIS Integration',
            'API Integration',
            'Third-Party Integration',
            'Custom API',
            'Legacy System Integration'
          ]
        },
        {
          name: '🏗️ INFRASTRUCTURE',
          items: [
            'On-Premise Option',
            'Private Cloud',
            'Dedicated Infrastructure',
            'Custom Deployment',
            'Data Migration'
          ]
        },
        {
          name: '🔒 SECURITY',
          items: [
            'Custom Security Policy',
            'Advanced Access Control',
            'Custom Audit Requirement',
            'Custom Compliance Requirement',
            'Custom SLA'
          ]
        },
        {
          name: '🤝 SERVICE',
          items: [
            'Dedicated Account Manager',
            'Dedicated Technical Support',
            'Training',
            'Onboarding',
            'Implementation Assistance',
            'Data Migration Assistance',
            'White-Label Option',
            'Custom Contract',
            'AI Custom'
          ]
        }
      ],
      highlightFeatures: [
        'Semua fitur Enterprise',
        'Custom Module & Dashboard',
        'Custom Workflow & Report',
        'Custom Integration (ERP, CRM, HRIS)',
        'On-Premise & Private Cloud',
        'Dedicated Account Manager',
        'White-Label Option',
        'Custom SLA & Security',
      ],
      isPopular: false,
      buttonText: 'Hubungi Sales',
      bgColor: 'bg-gray-900',
      borderColor: 'border-gray-700',
      textColor: 'text-white',
      priceColor: 'text-white',
      buttonStyle: 'bg-white text-gray-900 hover:bg-gray-100',
      isCustom: true,
      tooltip: 'Solusi enterprise yang sepenuhnya disesuaikan dengan kebutuhan bisnis Anda',
    },
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID').format(price);
  };

  return (
    <section id="harga" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* ===== HEADER ===== */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-zentra-50 rounded-full px-4 py-1.5 mb-4">
            <Icon icon="mdi:tag-multiple" className="text-zentra-500 text-sm" />
            <span className="text-xs font-medium text-zentra-600">Pricing</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Pilih Paket yang Sesuai dengan{' '}
            <br className="hidden sm:block" />
            Kebutuhan Perusahaan Anda
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Mulai gratis, upgrade kapan saja. Semua paket termasuk akses fitur core dan support tim kami.
          </p>

          {/* ===== TOGGLE BULANAN/TAHUNAN ===== */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <span className={`text-sm font-medium transition-colors ${!isYearly ? 'text-gray-900' : 'text-gray-400'}`}>
              Bulanan
            </span>
            <button
              onClick={togglePricing}
              className={`relative w-12 h-6 rounded-full transition-colors ${isYearly ? 'bg-zentra-600' : 'bg-zentra-200'}`}
            >
              <div
                className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform shadow-sm ${
                  isYearly ? 'translate-x-6' : 'translate-x-1'
                }`}
              ></div>
            </button>
            <span className={`text-sm font-medium transition-colors ${isYearly ? 'text-gray-900' : 'text-gray-400'}`}>
              Tahunan <span className="text-xs text-emerald-600 font-semibold">-20%</span>
            </span>
          </div>
        </div>

        {/* ===== PRICING CARDS ===== */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {plans.map((plan, index) => {
            const showAll = showAllFeatures[plan.name] || false;
            const categories = plan.featureCategories || [];
            const totalItems = categories.reduce((acc, cat) => acc + cat.items.length, 0);
            const visibleItems = 8;

            return (
              <div
                key={index}
                className={`pricing-card ${plan.bgColor} rounded-2xl p-7 border ${plan.borderColor} transition-all duration-300 hover:shadow-lg flex flex-col relative ${
                  plan.isPopular ? 'shadow-lg shadow-zentra-500/20' : ''
                } ${plan.isPopular ? 'ring-2 ring-zentra-500/30' : ''}`}
              >
                {/* ===== POPULAR BADGE ===== */}
                {plan.isPopular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg">
                      ⭐ Paling Populer
                    </span>
                  </div>
                )}

                {/* ===== PLAN HEADER ===== */}
                <div className="mb-6">
                  <h3 className={`text-lg font-semibold ${plan.textColor} mb-1`}>
                    {plan.icon} {plan.name}
                  </h3>
                  <p className={`text-xs ${plan.isCustom ? 'text-gray-400' : 'text-gray-400'} mb-4`}>
                    {plan.description}
                  </p>
                  {plan.isCustom ? (
                    <div className="flex items-baseline gap-1">
                      <span className="text-3xl font-bold text-white">Custom</span>
                    </div>
                  ) : (
                    <div className="flex items-baseline gap-1">
                      <span className={`text-3xl font-bold ${plan.priceColor}`}>
                        Rp{formatPrice(isYearly ? plan.priceYearly : plan.priceMonthly)}
                      </span>
                      <span className={`text-sm ${plan.isCustom ? 'text-gray-400' : 'text-gray-400'}`}>
                        /{isYearly ? 'tahun' : 'bulan'}
                      </span>
                    </div>
                  )}
                  {plan.isCustom && (
                    <p className="text-xs text-gray-400 mt-1">Hubungi tim sales kami</p>
                  )}
                  {!plan.isCustom && isYearly && (
                    <p className="text-xs text-emerald-600 font-medium mt-1">
                      Hemat Rp{formatPrice((plan.priceMonthly * 12) - plan.priceYearly)}/tahun!
                    </p>
                  )}
                </div>

                {/* ===== FEATURES WITH SCROLL ===== */}
                <div className="flex-1 mb-6 min-h-[200px]">
                  <div className={`space-y-3 ${!showAll && categories.length > 0 ? 'max-h-[240px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pr-1' : ''}`}>
                    {categories.map((category, catIdx) => (
                      <div key={catIdx}>
                        <h4 className={`text-xs font-semibold ${plan.isCustom ? 'text-gray-400' : 'text-gray-400'} mb-1.5`}>
                          {category.name}
                        </h4>
                        <div className="space-y-1.5">
                          {category.items.map((item, itemIdx) => (
                            <div key={itemIdx} className="flex items-start gap-2">
                              <Icon
                                icon="mdi:check-circle"
                                className={`text-sm ${
                                  plan.isCustom ? 'text-zentra-400' : 'text-emerald-500'
                                } flex-shrink-0 mt-0.5`}
                              />
                              <span className={`text-sm ${plan.isCustom ? 'text-gray-300' : 'text-gray-600'}`}>
                                {item}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* ===== SHOW MORE BUTTON ===== */}
                  {categories.length > 0 && totalItems > visibleItems && (
                    <button
                      onClick={() => toggleShowAllFeatures(plan.name)}
                      className="text-xs text-zentra-600 hover:text-zentra-700 font-medium mt-3 flex items-center gap-1 transition-colors"
                    >
                      {showAll ? (
                        <>
                          <Icon icon="mdi:chevron-up" className="text-sm" />
                          Tampilkan Lebih Sedikit
                        </>
                      ) : (
                        <>
                          <Icon icon="mdi:chevron-down" className="text-sm" />
                          Lihat Semua Fitur ({totalItems})
                        </>
                      )}
                    </button>
                  )}
                </div>

                {/* ===== CTA BUTTON ===== */}
                <button
                  className={`w-full py-3 rounded-xl font-semibold text-sm transition-all ${
                    plan.buttonStyle
                  }`}
                  onClick={() => {
                    if (plan.isCustom) {
                      window.location.href = 'mailto:sales@zentra.com';
                    }
                  }}
                >
                  {plan.buttonText}
                </button>

                {/* ===== TOOLTIP ===== */}
                {plan.tooltip && (
                  <div className="mt-2 text-center">
                    <span className="text-[10px] text-gray-400">{plan.tooltip}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ===== COMPARISON TABLE TRIGGER ===== */}
        <div className="text-center mt-8">
          <button className="text-sm text-zentra-600 hover:text-zentra-700 font-medium flex items-center gap-2 mx-auto transition-colors">
            <Icon icon="mdi:table-arrow-right" className="text-lg" />
            Lihat Perbandingan Fitur Lengkap
          </button>
        </div>

        {/* ===== BOTTOM CTA ===== */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <button className="gradient-btn text-white text-sm font-semibold px-8 py-3 rounded-xl hover:shadow-lg hover:shadow-zentra-500/25 transition-all flex items-center gap-2">
            <Icon icon="mdi:whatsapp" className="text-lg" />
            Konsultasi Gratis
          </button>
          <button className="bg-white border border-gray-200 text-gray-700 text-sm font-semibold px-8 py-3 rounded-xl hover:bg-gray-50 transition-all flex items-center gap-2">
            <Icon icon="mdi:phone" className="text-lg" />
            Hubungi Sales
          </button>
        </div>

        {/* ===== FOOTER NOTE ===== */}
        <div className="text-center mt-8">
          <p className="text-xs text-gray-400">
            * Semua paket termasuk trial 14 hari gratis. Tidak perlu kartu kredit.
            <br />
            ** Harga sudah termasuk PPN
          </p>
        </div>

      </div>
    </section>
  );
};

export default Pricing;
